import { render, staticRenderFns } from "./orthopedic-card-review.vue?vue&type=template&id=6b7bb81e&scoped=true&"
import script from "./orthopedic-card-review.vue?vue&type=script&lang=js&"
export * from "./orthopedic-card-review.vue?vue&type=script&lang=js&"
import style0 from "./orthopedic-card-review.vue?vue&type=style&index=0&id=6b7bb81e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7bb81e",
  null
  
)

export default component.exports